import { useMemo } from 'react';
import { BreadcrumbsWrapper } from './Breadcrumbs.style';

const Breadcrumbs = ({
  isUsingVersion,
  items,
}: {
  isUsingVersion: boolean;
  items: PageContext['breadcrumbs'];
}) => {
  const filteredItems = items.filter(
    (item) => item.isProduct && item.hasProductVersionInPath === isUsingVersion
  );

  const crumbs = useMemo(
    () => filteredItems.map((filteredItems) => filteredItems.name).join(' | '),
    [filteredItems]
  );

  return <BreadcrumbsWrapper>{crumbs}</BreadcrumbsWrapper>;
};

export default Breadcrumbs;
